const keyMirror = require('keymirror');

module.exports = keyMirror({
    GET_BLOCKED_PUBLIC_EMAIL_DOMAIN: null,
    DELETE_BLOCKED_PUBLIC_EMAIL_DOMAIN: null,
    GET_BLOCKED_SPAM_DOMAIN: null,
    DELETE_BLOCKED_SPAM_DOMAIN: null,
    DOWNLOAD_BLOCKED_DOMAIN:null
    
});
// export const DummyPublicEmailDomains = [
//   { slno: 1, domainName: "gmail.com (http://gmail.com/)" },
//   { slno: 2, domainName: "yahoo.com (http://yahoo.com/)" },
//   { slno: 3, domainName: "hotmail.com (http://hotmail.com/)" },
//   { slno: 4, domainName: "yahoo.co.in (http://yahoo.co.in/)" },
//   { slno: 5, domainName: " aol.com (http://aol.com/)" },
//   { slno: 6, domainName: "abc.com (http://abc.com/)" },
//   { slno: 7, domainName: "xyz.com (http://xyz.com/)" },
//   { slno: 8, domainName: "pqr.com (http://pqr.com/)" },
// ];
